/**
 * Export loadData calls from ducks modules of different containers
 *
 * MVP (pure discovery):
 * - Keep: Search, Listing, Auth, Profile, CMS, Landing
 * - Remove from runtime: Checkout/Transactions/Offers/Quotes/Inbox/Payments/Stripe/ManageListings
 *   (These can be re-added later when you turn Sharetribe/transactions back on.)
 */

import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';

import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';

// Buyer-facing profile pages (keep if you still use them in MVP)
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';

// ------------------------------------------------------------
// FUTURE (transactions / roaster / payments) — intentionally removed from MVP runtime:
//
// import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
// import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
// import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
// import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
// import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
// import { loadData as MakeOfferPageLoader } from './MakeOfferPage/MakeOfferPage.duck';
// import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
// import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
// import { loadData as RequestQuotePageLoader } from './RequestQuotePage/RequestQuotePage.duck';
// import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
// import {
//   loadData as TransactionPageLoader,
//   setInitialValues as TransactionPageInitialValues,
// } from './TransactionPage/TransactionPage.duck';
// ------------------------------------------------------------

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },

    // Core discovery pages
    SearchPage: {
      loadData: SearchPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },

    // Buyer pages (optional but usually fine to keep)
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },

    // FUTURE (transactions/payments/etc.) removed for MVP
    // CheckoutPage: { setInitialValues: CheckoutPageInitialValues },
    // TransactionPage: { loadData: TransactionPageLoader, setInitialValues: TransactionPageInitialValues },
    // InboxPage: { loadData: InboxPageLoader },
    // MakeOfferPage: { loadData: MakeOfferPageLoader },
    // RequestQuotePage: { loadData: RequestQuotePageLoader },
    // ManageListingsPage: { loadData: ManageListingsPageLoader },
    // StripePayoutPage: { loadData: StripePayoutPageLoader },
    // PaymentMethodsPage: { loadData: PaymentMethodsPageLoader },
  };
};

export default getPageDataLoadingAPI;